import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./saida-estoque-listar/saida-estoque-listar.module').then(m => m.SaidaEstoqueListarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./saida-estoque-inserir/saida-estoque-inserir.module').then(m => m.SaidaEstoqueInserirModule) },
    { path: 'inserir-identificada', data: { breadcrumb : 'Identificada' }, loadChildren: () => import('./saida-estoque-inserir-identificada/saida-estoque-inserir-identificada.module').then(m => m.SaidaEstoqueInserirIdentificadaModule) }

  ])],
  exports: [RouterModule]
})
export class SaidaEstoqueRoutingModule { }
